/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ForwardedRef, RefObject, forwardRef, useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import { Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// eslint-disable-next-line
// const iconeSVG = "<svg xmlns='http://www.w3.org/2000/svg' height='40px' viewBox='0 -960 960 960' width='40px' fill='#e8eaed'><path d='M80-240v-80q38 0 56.5-20t77.5-20q59 0 77.5 20t54.5 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20q38 0 55.5-20t76.5-20q59 0 77.5 20t56.5 20v80q-57 0-77.5-20T746-280q-36 0-54.5 20T614-240q-57 0-77.5-20T480-280q-38 0-56.5 20T346-240q-59 0-76.5-20T214-280q-38 0-56.5 20T80-240Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-440q-36 0-54.5 20T614-400q-57 0-77.5-20T480-440q-38 0-55.5 20T348-400q-59 0-78.5-20T214-440q-36 0-56.5 20T80-400Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-600q-36 0-54.5 20T614-560q-57 0-77.5-20T480-600q-38 0-55.5 20T348-560q-59 0-78.5-20T214-600q-36 0-56.5 20T80-560Z'/></svg>";
// eslint-disable-next-line
const iconeSVG = "<svg xmlns='http://www.w3.org/2000/svg' width='40px' height='40px' viewBox='0 -68 1160 1160' fill='#e8eaed'><path d='M1115.534025 859.681661c-28.641292 0-55.658593 9.153403-78.542099 26.426759l-43.847751 33.217993c-14.615917 11.072664-35.137255 11.2203-49.900807 0l-43.847751-33.217993a130.435986 130.435986 0 0 0-156.936563 0l-43.847751 33.217993c-14.763552 11.072664-35.28489 11.072664-49.900807 0l-43.847751-33.217993c-43.55248-33.070358-103.344867-34.546713-148.668973-5.314879V813.471742l45.324106-34.399078a41.633218 41.633218 0 0 1 49.900807 0l43.847751 33.217993c46.209919 35.137255 110.726644 34.989619 156.936563 0l43.847751-33.217993c14.763552-11.072664 35.28489-11.2203 49.900807 0l43.847751 33.217993a129.623991 129.623991 0 0 0 78.542099 26.279124c27.755479 0 55.363322-8.710496 78.542099-26.279124l43.847751-33.217993c7.086505-5.462514 15.649366-8.267589 24.655133-8.415225a44.231603 44.231603 0 0 0 43.995386-44.585928 44.26113 44.26113 0 0 0-44.290657-43.995386h-0.295271c-28.198385 0.147636-55.068051 9.301038-77.508651 26.426759l-43.847751 33.217993c-14.615917 11.072664-35.28489 11.072664-49.900807 0l-43.847751-33.217993a129.99308 129.99308 0 0 0-156.936563 0l-43.847751 33.217993c-14.763552 11.2203-35.28489 11.2203-49.900807 0l-43.847751-33.217993c-43.55248-33.070358-103.344867-34.546713-148.668973-5.314879v-67.3218l45.324106-34.399077a41.633218 41.633218 0 0 1 49.900807 0l43.847751 33.217993c46.209919 35.137255 110.726644 34.989619 156.936563 0l43.847751-33.217993c14.763552-11.2203 35.28489-11.2203 49.900807 0l43.847751 33.217993a129.623991 129.623991 0 0 0 78.542099 26.279124c27.755479 0 55.363322-8.710496 78.542099-26.279124l43.847751-33.217993c7.086505-5.314879 15.50173-8.267589 24.359862-8.415225a44.290657 44.290657 0 0 0-0.590542-88.581315h-0.590542c-27.903114 0.442907-54.329873 9.448674-76.622838 26.426759l-43.847751 33.217993c-14.615917 11.072664-35.28489 11.072664-49.900807 0l-43.847751-33.217993a130.435986 130.435986 0 0 0-156.936563 0l-43.847751 33.217993c-14.763552 11.2203-35.28489 11.2203-49.900807 0l-43.847751-33.217993c-43.55248-33.070358-103.344867-34.546713-148.668973-5.314879v-67.321799l45.324106-34.399077a41.633218 41.633218 0 0 1 49.900807 0l43.847751 33.217993a129.99308 129.99308 0 0 0 156.936563 0l43.847751-33.217993c14.763552-11.2203 35.28489-11.2203 49.900807 0l43.847751 33.217993a129.623991 129.623991 0 0 0 78.542099 26.279123c27.755479 0 55.363322-8.710496 78.542099-26.279123l43.847751-33.217993c6.93887-5.314879 15.354095-8.267589 24.064591-8.415225 24.507497-0.590542 43.847751-20.816609 43.404844-45.176471s-20.816609-43.995386-45.17647-43.404844c-27.607843 0.590542-53.739331 9.743945-75.737025 26.426759l-43.847751 33.217993c-14.615917 11.072664-35.137255 11.2203-49.900807 0l-43.847751-33.217993a130.435986 130.435986 0 0 0-156.936563 0l-43.847751 33.217993c-14.763552 11.072664-35.28489 11.072664-49.900807 0l-43.847751-33.217993c-43.55248-33.070358-103.344867-34.546713-148.668973-5.314879v-67.321799l45.324106-34.399078a41.633218 41.633218 0 0 1 49.900807 0l43.847751 33.217993c46.209919 35.137255 110.726644 34.989619 156.936563 0l43.847751-33.217993c14.763552-11.2203 35.28489-11.2203 49.900807 0l43.847751 33.217993a129.623991 129.623991 0 0 0 78.542099 26.279124c27.755479 0 55.363322-8.710496 78.542099-26.279124l43.847751-33.217993c6.93887-5.167243 15.058824-8.119954 23.76932-8.415225a44.246367 44.246367 0 0 0 42.961938-45.619377 44.246367 44.246367 0 0 0-44.290658-42.961937h-1.32872c-27.164937 0.738178-53.001153 9.89158-74.703575 26.279123l-43.847751 33.217993c-14.615917 11.072664-35.28489 11.072664-49.900807 0l-43.847751-33.217993a130.435986 130.435986 0 0 0-156.936563 0l-43.847751 33.217993c-14.763552 11.2203-35.28489 11.2203-49.900807 0l-43.847751-33.217993c-43.55248-33.070358-103.344867-34.546713-148.668974-5.167243V0H170.519031L0 1024h456.046136v-33.070358l45.324106-34.399077a41.633218 41.633218 0 0 1 49.900808 0l43.84775 33.217993c46.209919 34.989619 110.726644 35.137255 156.936563 0l43.847751-33.217993c14.763552-11.072664 35.28489-11.2203 49.900808 0l43.84775 33.217993a129.623991 129.623991 0 0 0 78.5421 26.279124c27.755479 0 55.363322-8.710496 78.542099-26.279124l43.847751-33.217993a41.337947 41.337947 0 0 1 24.950403-8.415225 44.231603 44.231603 0 1 0 0-88.433679z m-748.069204 75.737024H104.525952L245.517878 88.581315h121.799308v846.83737z'/></svg>";

const barragemIcon = L.divIcon({
	className: 'my-custom-icon',
	html: iconeSVG,
	iconSize: [0, 0],
	iconAnchor: [21, 40],
	popupAnchor: [-2, -30]
});

export type MarkerPoint = {
	uuid: string;
	position: [number, number];
	title?: string;
	type?: string;
	ew?: string;
	ns?: string;
	elev?: number;
	update?: string;
	route: string;
	showMarker: boolean;
	icone?: string;
	faixa_verde?: string;
	faixa_amarela?: string;
	faixa_laranja?: string;
	faixa_vermelha?: string;
	nivel_alerta?: string,
	lat?: string,
	lon?: string,
};

export type MapProps = {
	center: [number, number];
	markerPoints?: MarkerPoint[];
	type: string;
	show: boolean;
	ref?: RefObject<HTMLDivElement>;
	isLocation: boolean;
	zoom?: number;
	heightUser?: string;
	damName: string;
	isFullScreen?: boolean;
	lat?: string,
	lon?: string,
};

function sizeSVG(svgString: string | undefined, novoTamanho: number, nivel_alerta?: string) {
	if (!svgString) return;

	function getCor(nivel_alerta: string) {
		switch (nivel_alerta) {
			case 'Normal':
				return '#00FF00';
			case 'Atenção':
				return '#FFD700';
			case 'Alerta':
				return '#FFA500';
			case 'Emergência':
				return '#FF0000';
			default:
				return '#00FF00';
		}
	}

	let updatedSVG = svgString;

	// Atualiza width e height
	updatedSVG = updatedSVG.replace(/width=['"][^'"]*['"]/g, `width="${novoTamanho}"`);
	updatedSVG = updatedSVG.replace(/height=['"][^'"]*['"]/g, `height="${novoTamanho}"`);

	const cor = nivel_alerta ? getCor(nivel_alerta) : undefined;

	if (cor) {
		// Substitui todos os fill='...' ou fill="..." por nova cor
		updatedSVG = updatedSVG.replace(/fill=['"][^'"]*['"]/g, `fill="${cor}"`);
	}

	// Garante que style de tamanho está presente
	if (/style=/.test(updatedSVG)) {
		updatedSVG = updatedSVG.replace(/style=['"][^'"]*['"]/, `style="width: ${novoTamanho}px; height: ${novoTamanho}px;"`);
	} else {
		updatedSVG = updatedSVG.replace(
			/<svg([^>]*)>/,
			`<svg$1 style="width: ${novoTamanho}px; height: ${novoTamanho}px;">`
		);
	}

	return updatedSVG;
}





const MarkerDam = ({ possition, damName, lat, lon }: { possition: [number, number], damName: string, lat: string, lon: string }) => {
	return (
		<Marker position={possition} icon={barragemIcon} >
			<Tooltip permanent={true} direction='bottom'>
				<Typography>{damName}</Typography>
				{/* <Typography>Latitude: {lat}</Typography>
				<Typography>Longitude: {lon}</Typography> */}
				<Popup>
					<div style={{ maxHeight: '20rem', overflowY: 'auto' }}>
						<Typography>Latitude: {Number(lat).toFixed(4)}</Typography>
						<Typography>Longitude: {Number(lon).toFixed(4)}</Typography>
					</div>
				</Popup>
			</Tooltip>
		</Marker>
	);
};

const PopUpSelect = ({ isLocation, markerPoints, show, center, damName }:
	{
		isLocation: boolean,
		markerPoints: MarkerPoint[],
		show: boolean,
		center: [number, number],
		damName: string
	}) => {

	const navigate = useNavigate();
	
	return (
		<div>
			{
				isLocation ?
					<div>
						{markerPoints.map(({ position, title, route }, index) => (
							<Marker key={index} position={position} icon={barragemIcon} >
								<Tooltip permanent={true} direction='bottom'>
									{title}
								</Tooltip>
								<Popup>
									<div>
										<h2>{title}</h2>
										<Button variant='contained' fullWidth onClick={() => navigate(route)}>
											Detalhes
										</Button>
									</div>
								</Popup>
							</Marker>
						))}
					</div>
					:
					<div>
						{markerPoints.map(({ position, title, type, ew, ns, elev, update, showMarker, icone, faixa_amarela, faixa_laranja, faixa_verde, faixa_vermelha, nivel_alerta }, index) => (
							showMarker ? (
								<Marker key={index} position={position}
									icon={L.divIcon({
										className: 'marker',
										html: sizeSVG(icone, 35, nivel_alerta),
										iconSize: [0, 0],
										iconAnchor: [21, 40],
										popupAnchor: [-2, -30]
									})}
								>
									{show ? (
										<Tooltip permanent={true} direction='bottom'>
											{title}
										</Tooltip>
									) : null}
									<Popup>
										<div style={{ maxHeight: '20rem', overflowY: 'auto' }}>
											<h2>{title}</h2>
											<h4>{type}</h4>
											<Divider />
											<h4>UTM EW: {ew} </h4>
											<h4>UTM NS: {ns} </h4>
											<Divider />
											{faixa_verde &&
												<h4>Limite Normal: {faixa_verde}</h4>
											}
											{faixa_amarela &&
												<h4>Limite Atenção: {faixa_amarela}</h4>
											}
											{faixa_laranja &&
												<h4>Limite Alerta: {faixa_laranja}</h4>
											}
											{faixa_vermelha &&
												<h4>Limite Emergência: {faixa_vermelha}</h4>
											}
											<Divider />
											<h4></h4>
											<h4>Dados da última leitura:</h4>
											<h4>Data: {update}</h4>
											<h4>Alerta: {nivel_alerta}</h4>
										</div>
									</Popup>
								</Marker>
							) : null))}
					</div>
			}
		</div>
	);
};


const MapControl = ({ changeMapUrl }: { changeMapUrl: (newUrl: string) => void }) => {

	const [variant, setVariant] = useState<string>('Satélite');

	function changeButtom(type: string) {

		if (type == 'Satélite') {
			changeMapUrl('https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}');
			setVariant('Satélite');
		} else if (type == 'Topográfico') {
			changeMapUrl('https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}');
			setVariant('Topográfico');
		}

	}

	return (
		<div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 1000, gap: '50px' }}>
			<Button variant='contained' style={{ marginRight: '10px', ...(variant !== 'Satélite' ? { backgroundColor: 'white', color: 'black' } : {}) }} onClick={() => changeButtom('Satélite')} sx={{ borderRadius: '25px' }}>
				Satélite
			</Button>
			<Button variant='contained' style={variant !== 'Topográfico' ? { backgroundColor: 'white', color: 'black' } : {}} onClick={() => changeButtom('Topográfico')} sx={{ borderRadius: '25px' }}>
				Topográfico
			</Button>
		</div>
	);
};

export const MapRender: React.ForwardRefRenderFunction<HTMLDivElement, MapProps> = (
	{ show, center, markerPoints = [], isLocation, zoom = 18, damName, isFullScreen, lat, lon },
	ref: ForwardedRef<HTMLDivElement>
) => {
	const leafletMapInstanceRef = useRef<L.Map | null>(null);

	const [tileLayerUrl, setTileLayerUrl] = useState(
		'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
	);

	const changeMapUrl = (newUrl: string) => {
		setTileLayerUrl(newUrl);
	};

	const corner1 = L.latLng(-55.98, -81.3);
	const corner2 = L.latLng(12.5, -34.8);
	const bounds = L.latLngBounds(corner1, corner2);

	useEffect(() => {
		if (ref && typeof ref !== 'function' && ref.current) {
			const mapElement = ref.current.querySelector('.leaflet-container') as HTMLElement;
			if (mapElement) {
				const map = (mapElement as any)._leaflet_map;
				if (map) {
					leafletMapInstanceRef.current = map;
					map.invalidateSize();
				}
			}
		}
	}, [isFullScreen, ref]);

	return (
		<div
			style={{
				position: isFullScreen ? 'fixed' : 'relative',
				width: isFullScreen ? '100vw' : '100%',
				height: isFullScreen ? '100vh' : '62vh',
				top: isFullScreen ? '0' : 'auto',
				left: isFullScreen ? '0' : 'auto',
				zIndex: isFullScreen ? 9999 : 'auto',
				backgroundColor: isFullScreen ? 'white' : 'transparent',
				borderRadius: isFullScreen ? '0px' : '15px',
				transition: 'all 0.3s ease-in-out',
				overflow: 'hidden'
			}}
			ref={ref}
		>
			<MapContainer
				center={center}
				zoom={zoom}
				maxZoom={18}
				minZoom={5}
				maxBounds={bounds}
				style={{
					height: '100%',
					width: '100%',
					borderRadius: 'inherit',
					position: 'relative',
				}}
			>
				<TileLayer url={tileLayerUrl} attribution='&copy; <a href="https://about.google/brand-resource-center/">GoogleMaps</a>' />
				<PopUpSelect isLocation={isLocation} markerPoints={markerPoints} show={show} center={center} damName={damName} />
				{damName !== '' ? <MarkerDam possition={center} damName={damName} lat={lat ?? '0'} lon={lon ?? '0'} /> : null}
			</MapContainer>
			<MapControl changeMapUrl={changeMapUrl} />
		</div>
	);
};

export const ForwardedMapRender = forwardRef(MapRender);